import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';

import IconLeft from 'material-ui/svg-icons/navigation/chevron-left';
import IconRight from 'material-ui/svg-icons/navigation/chevron-right';

import { Grid, GridHeader, GridFooter, GridBody, GridRow, GridCell } from '../../components/basic/grid';
import PlainTextField from '../../components/basic/PlainTextField';
import IconButton from '../../components/basic/IconButton';

import * as teamsActions from '../../actions/entities/TeamsActions';

const trimToNull = (val) => {
  if (!val) {
    return null;
  }
  const trimmed = val.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed;
};

const Row = ({ id, name, company, department }) => (
  <Link to={`/settings/teams/${id}`}>
    <GridRow className="row">
      <GridCell className="col-sm-4">
        <span>{name}</span>
      </GridCell>
      <GridCell className="col-sm-4">
        <span>{company && company.name || 'N/A'}</span>
      </GridCell>
      <GridCell className="col-sm-4">
        <span>{department && department.name || 'N/A'}</span>
      </GridCell>
    </GridRow>
  </Link>
);

const PAGE_SIZE = 50;

class TeamsContainer extends React.Component {
  state = { filter: '' };

  componentDidMount() {
    this.loadTeams();
  }

  componentWillUnmount() {
    if (this._filterChangeTimeout) {
      clearTimeout(this._filterChangeTimeout);
    }
  }

  loadTeams = (page) => {
    const { fetchTeams } = this.props;
    const filter = trimToNull(this.state.filter);
    let nameFilter = filter;
    const additionalQuery = { deleted: false };
    if (filter) {
      const cIdx = filter.indexOf("company:");
      const cLen = "company:".length;
      if (cIdx === 0) {
        const cleanFilter = filter.substring(cLen);
        let companyName;
        if (cleanFilter[0] === '"' || cleanFilter[0] === "'") {
          companyName = cleanFilter.substring(1, cleanFilter.indexOf(cleanFilter[0], 1));
          nameFilter = cleanFilter.substring(companyName.length + 2).trim();
        } else {
          companyName = cleanFilter.split(" ")[0];
          nameFilter = cleanFilter.substring(companyName.length).trim();
        }
        const trimmedCompanyName = companyName.trim();
        if (trimmedCompanyName) {
          additionalQuery['company.name'] = trimmedCompanyName;
        }
      } else if (cIdx > 0) {
        const companyName = filter.substring(cIdx + cLen).trim();
        additionalQuery['company.name'] = companyName;
        nameFilter = filter.substring(0, cIdx).trim();
      }
    }
    fetchTeams({ page: page || 0, size: PAGE_SIZE }, nameFilter, additionalQuery);
  };

  debouncedLoadTeams = () => {
    if (this._filterChangeTimeout) {
      clearTimeout(this._filterChangeTimeout);
    }
    this._filterChangeTimeout = setTimeout(this.loadTeams, 300);
  };

  handleFilterChange = (e) => this.setState({ filter: e.target.value }, this.debouncedLoadTeams);
  handleCurrentPageChange = (p) => this.loadTeams(p);

  render() {
    const {
      teams: { items, page },
    } = this.props;
    const { filter } = this.state;
    
    return (
      <div className="flex flex1 flex-column">
        <div style={{ background: 'white', padding: '16px 16px 0' }}>
          <h2 style={{ margin: 0 }}>Teams</h2>
        </div>
        <Grid>
          <GridHeader>
            <GridRow className="row">
              <GridCell className="col-sm-4">
                <span>Name</span>
              </GridCell>
              <GridCell className="col-sm-4">
                <span>Company</span>
              </GridCell>
              <GridCell className="col-sm-4">
                <span>Department</span>
              </GridCell>
            </GridRow>
            <GridRow className="row" style={{ padding: 0 }}>
              <GridCell className="col-sm-12" style={{ padding: 0 }}>
                <PlainTextField
                  placeholder="Filter..."
                  value={filter}
                  onChange={this.handleFilterChange}
                  label="Filter"
                />
              </GridCell>
            </GridRow>
          </GridHeader>
          <ScrollArea smoothScrolling>
            <GridBody>
              {R.map(
                (team) => (
                  <Row key={team.id} {...team} />
                ),
                items
              )}
            </GridBody>
          </ScrollArea>
          <GridFooter>
            <GridRow className="Grid-pagination row">
              {page && (
                <GridCell className="col-sm-12 text-right">
                  <span>
                    {page.number * page.size + 1}-{Math.min(page.totalElements, (page.number + 1) * page.size)} of{' '}
                    {page.totalElements}
                  </span>
                  <IconButton onClick={() => this.handleCurrentPageChange(page.number - 1)} disabled={page.number <= 0}>
                    <IconLeft />
                  </IconButton>
                  <IconButton
                    onClick={() => this.handleCurrentPageChange(page.number + 1)}
                    disabled={(page.number + 1) * page.size > page.totalElements}
                  >
                    <IconRight />
                  </IconButton>
                </GridCell>
              )}
            </GridRow>
          </GridFooter>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ teams: state.entities.teams });

export default connect(mapStateToProps, teamsActions)(TeamsContainer); 


// WEBPACK FOOTER //
// ./src/containers/private/TeamsContainer.js